export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7991.4c56fcb6.jpg";